export default __webpack_public_path__ + "static/media/configuration.9f839bd8.svg";